<!-- 统计分析 -->
<template>
  <div>
    <!-- 搜索区域 -->
    <div class="searchBox">
      <div class="Search">
        <div class="searchTxt">统计类型</div>
        <el-select
          v-model="queryReport.name"
          @change="getReport()"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in nameTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="Search">
        <div class="searchTxt">人员姓名</div>
        <el-input
          placeholder="请输入人员姓名"
          size="medium"
          v-model="queryReport.ename"
          @change="getReport()"
          clearable
        >
        </el-input>
      </div>
      <div class="Search">
        <div class="searchTxt">项目名称</div>
        <el-input
          placeholder="请输入项目名称"
          size="medium"
          v-model="queryReport.dname"
          @change="getReport()"
          clearable
        >
        </el-input>
      </div>

      <div class="Search1">
        <div class="searchTxt">拍摄时间</div>
        <el-date-picker
          @input="getReport()"
          v-model="Time"
          type="datetimerange"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          align="left"
        >
          <!-- value-format="yyyy-MM-dd HH:mm:ss" -->
        </el-date-picker>
      </div>
      <div class="Search">
        <div class="searchTxt">是否锁定</div>
        <el-checkbox
          class=""
          @change="getReport()"
          v-model="queryReport.lockflag"
        ></el-checkbox>
      </div>
    </div>

    <!-- 卡片区域 -->
    <el-card class="right-card">
      <!-- 统计分析信息表格区域 -->
      <el-table
        :data="reportList"
        :header-cell-style="{
          background: '#0395d9',
          color: '#505255',
          textAlign: 'center',
        }"
        :cell-style="{ color: '#4d5a6a', textAlign: 'center' }"
      >
        <el-table-column
          prop="media_emp_name"
          v-if="this.queryReport.name == 'emp'"
          label="人员姓名"
        >
        </el-table-column>
        <el-table-column
          prop="media_emp_no"
          v-if="this.queryReport.name == 'emp'"
          label="人员编号"
        >
        </el-table-column>
        <el-table-column
          prop="media_dep_name"
          v-if="this.queryReport.name == 'dep'"
          label="项目名称"
        >
        </el-table-column>
        <el-table-column
          prop="mtag_name"
          v-if="this.queryReport.name == 'tag'"
          label="标签名称"
        >
        </el-table-column>
        <el-table-column
          prop="dates"
          v-if="
            this.queryReport.name == 'day' ||
            this.queryReport.name == 'month' ||
            this.queryReport.name == 'year'
          "
          label="拍摄时间"
        >
        </el-table-column>
        <el-table-column prop="filecount" label="文件总数"> </el-table-column>
        <el-table-column prop="videofiles" label="视频数量"> </el-table-column>
        <el-table-column prop="VideofilesSize" label="视频大小(MB)">
        </el-table-column>
        <el-table-column prop="VideofilesPlayLast" label="视频时长(分钟)">
        </el-table-column>
        <el-table-column prop="Audiofiles" label="音频数量"> </el-table-column>
        <el-table-column prop="AudiofilesSize" label="音频大小">
        </el-table-column>
        <el-table-column prop="AudiofilesPlayLast" label="音频时长(分钟)">
        </el-table-column>
        <el-table-column prop="Photofiles" label="图片数量"> </el-table-column>
        <el-table-column prop="PhotofilesSize" label="图片大小"> </el-table-column>
        <el-table-column prop="textfiles" label="文本数量"> </el-table-column>
        <el-table-column prop="textfilesSize" label="文本大小">
        </el-table-column>
        <el-table-column prop="outhorfiles" label="其他文件数量">
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="queryReport.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="queryReport.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 统计列表
      reportList: [],
      // 总数量
      total: 0,
      // 查询统计分析信息
      queryReport: {
        // 查询种类名称（emp,dep,day,month,year）
        name: "emp",
        // 开始时间
        btime: "",
        //结束时间
        etime: "",
        // 人员名称
        ename: "",
        // 单位名称
        dname: "",
        // 是否锁定
        lockflag: false,
        //  当前页
        page: 1,
        //  每页显示多少条
        pageSize: 10,
      },

      //统计类型
      nameTypeOptions: [
        {
          value: "emp",
          label: "人员",
        },
        {
          value: "dep",
          label: "项目",
        },
        {
          value: "tag",
          label: "标签",
        },
        {
          value: "day",
          label: "天",
        },
        {
          value: "month",
          label: "月",
        },
        {
          value: "year",
          label: "年",
        },
      ],

      // 时间选择器选择的开始和结束时间
      Time: "",
      // 时间选择器
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.getReport();
  },
  methods: {
    // 获取统计信息
    async getReport() {
      this.queryReport.btime = "";
      this.queryReport.etime = "";
      if (this.Time) {
        // 开始时间
        this.queryReport.btime = this.Time[0];
        // 结束时间
        this.queryReport.etime = this.Time[1];
      }

      const { data: res } = await this.$axios.post(
        `${this.$api}/report/type`,
        this.queryReport
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      if (res.data.rows) {
        this.reportList = res.data.rows;
        this.total = res.data.total;
      }
    },

    // 当每页显示条发生改变时触发
    handleSizeChange(size) {
      this.queryReport.pageSize = size;
      this.getReport();
    },
    // 当当前页发生改变时触发
    handleCurrentChange(current) {
      this.queryReport.page = current;
      this.getReport();
    },
  },
};
</script>


<style lang="less" scoped>
/* 新增按钮 */
.add-btn {
  float: left;
  margin-bottom: 10px;
}

.el-select {
  width: 100%;
}

.box-card {
  height: 400px !important;
  overflow: auto;
  margin: 0;
}

// el-dialog高度自适应，内容超出时中间出现滚动条
.common-dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
  .el-dialog {
    margin: 0 auto !important;
    position: relative;
    .el-dialog__header {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      width: 100%;
      height: 60px;
      z-index: 1;
    }
    .el-dialog__body {
      width: 100%;
      overflow: hidden;
      overflow-y: auto;
      max-height: 90vh; //最大高度为视口高度的90%
      padding-top: 80px;
      padding-bottom: 100px;
      z-index: 1;
    }
    .el-dialog__footer {
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 80px;
      z-index: 1;
    }
  }
}

.searchBox {
  border-bottom: 1px solid #0693c0;
  margin: 0 0 5px 0;
  height: 50px;
  width: 100%;
  display: flex;
  align-content: center;

  // 用户名搜索区域
  .Search {
    width: 300px;
    display: flex;
    align-items: center;
    margin-left: 20px;

    // 搜索标题
    .searchTxt {
      color: #0693c0;
      font-weight: bold;
      width: 100px;
    }
    /* element-input背景颜色改为透明，修改输入字体颜色 */
    /deep/ .el-input__inner {
      background-color: transparent;
      color: #0693c0;
      margin: 15px 0;
      border: 1px solid #0693c0;
    }
  }
  .Search1 {
    width: 450px;
    display: flex;
    align-items: center;
    margin-left: 30px;
    // 搜索标题
    .searchTxt {
      color: #0693c0;
      font-weight: bold;
      width: 80px;
    }
    /* element-input背景颜色改为透明，修改输入字体颜色 */
    /deep/ .el-input__inner {
      background-color: transparent;
      color: #0693c0;
      margin: 15px 0;
      border: 1px solid #0693c0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Main/EvidenceCenter/statistics.vue